import React, { Component } from "react"
import styled               from "styled-components"
import { media }            from "components/styled"
import { images }           from "config/index"
import debounce             from "utils/debounce"

class Search extends Component {
    constructor(props) {
        super(props)

        this.state = {
            query: "",
        }
        this.onSearchChange = debounce(this.props.onSearchChange, 500)
    }

    onChange = e => {
        this.setState({ query: e.target.value }, () => {
            this.onSearchChange(this.state.query, "search");
        });
    };

    render() {
        const { placeholder } = this.props

        return (
            <SearchBox>
                <input
                    type="search"
                    placeholder={placeholder}
                    className="search"
                    name="search"
                    value={this.state.query}
                    onChange={this.onChange}
                    autoComplete="off"
                />
            </SearchBox>
        )
    }
}

const SearchBox = styled.div`
  @media all and (min-width: 600px) and (max-width: 992px), (min-width: 1200px) {
    width: 52%;
  }
  .search {
    background: ${props => props.theme.primary.darkGrey}
      url(${images.icons.search}) no-repeat 15px 12px;
    border-radius: 20px;
    border: 0;
    box-shadow: var(--search-bar-shadow);
    color: var(--search-bar-color);
    font-size: ${props => props.theme.fontSize.md}px;
    font-family: ${props => props.theme.fontFamily.sansSerif};
    height: 40px;
    margin-bottom: 10px;
    padding: 0 20px 0 40px;
    width: 100%;
    ${media.tabletSmall`margin:0;`};
    /* ${media.desktop`width: 330px;`};
    ${media.desktopLarge`width: 380px;`}; */
    @media all and (min-width: 992px) and (max-width: 1200px) {
      margin-bottom: 10px;
    }
  }
`

export default Search



// WEBPACK FOOTER //
// ./src/components/layouts/search/search.js